import { render, staticRenderFns } from "./EmployeeNode.vue?vue&type=template&id=f97985bc&scoped=true&"
import script from "./EmployeeNode.vue?vue&type=script&lang=js&"
export * from "./EmployeeNode.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeNode.vue?vue&type=style&index=0&id=f97985bc&prod&scoped=true&lang=css&"
import style1 from "./EmployeeNode.vue?vue&type=style&index=1&id=f97985bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97985bc",
  null
  
)

export default component.exports